"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavList = _interopRequireDefault(require("./../lists/NavList"));
var _FooterNavigationModule = _interopRequireDefault(require("./../../scss/navigations/FooterNavigation.module.scss"));
require("./../../scss/navigations/FooterNavigation.scss");
function FooterNavigation(_ref) {
  let {
    sections = []
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: _FooterNavigationModule.default['footer-navigation'],
    "aria-labelledby": "footer-navigation"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "sr-only",
    id: "footer-navigation"
  }, "Footer Navigation"), sections.map((section, index) => {
    return /*#__PURE__*/_react.default.createElement(_NavList.default, {
      links: section.links,
      title: section.title,
      classname: section.classname,
      key: "footer-section-".concat(index + 1)
    });
  }));
}
var _default = exports.default = FooterNavigation;